// Generated by purs version 0.15.15
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var InvalidBlikCodeIsSymbol = {
    reflectSymbol: function () {
        return "InvalidBlikCode";
    }
};
var CardProcessingErrorIsSymbol = {
    reflectSymbol: function () {
        return "CardProcessingError";
    }
};
var OtherErrorIsSymbol = {
    reflectSymbol: function () {
        return "OtherError";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var InvalidBlikCode = /* #__PURE__ */ (function () {
    function InvalidBlikCode() {

    };
    InvalidBlikCode.value = new InvalidBlikCode();
    return InvalidBlikCode;
})();
var CardProcessingError = /* #__PURE__ */ (function () {
    function CardProcessingError() {

    };
    CardProcessingError.value = new CardProcessingError();
    return CardProcessingError;
})();
var OtherError = /* #__PURE__ */ (function () {
    function OtherError(value0) {
        this.value0 = value0;
    };
    OtherError.create = function (value0) {
        return new OtherError(value0);
    };
    return OtherError;
})();
var toFillFormTypeError = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof InvalidBlikCode && y instanceof InvalidBlikCode) {
                return true;
            };
            if (x instanceof CardProcessingError && y instanceof CardProcessingError) {
                return true;
            };
            if (x instanceof OtherError && y instanceof OtherError) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var genericError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return InvalidBlikCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return CardProcessingError.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new OtherError(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types.PaymentError (line 14, column 1 - line 14, column 65): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof InvalidBlikCode) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof CardProcessingError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof OtherError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types.PaymentError (line 14, column 1 - line 14, column 65): " + [ x.constructor.name ]);
    }
};
var showError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(InvalidBlikCodeIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CardProcessingErrorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(OtherErrorIsSymbol))))
};
var unscrambleDecodeError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericError)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(InvalidBlikCodeIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(CardProcessingErrorIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(OtherErrorIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeString1))))))(Unscramble_Generic.defaultOptions)
};
var encodeError = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericError)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidBlikCodeIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CardProcessingErrorIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OtherErrorIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var decodeError = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericError)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InvalidBlikCodeIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CardProcessingErrorIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OtherErrorIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))))
};
export {
    InvalidBlikCode,
    CardProcessingError,
    OtherError,
    genericError,
    eqError,
    showError,
    encodeError,
    decodeError,
    unscrambleDecodeError,
    toFillFormTypeError
};
